import React from 'react';
import { Heart, Shield, Users } from 'lucide-react';

const aboutData = {
  headline: "About Waisted Momma",
  story: "Waisted Momma was born from a simple belief: every woman deserves to feel confident, supported, and empowered in her own skin. As moms and women on our own self-improvement journeys, we understand the challenges of finding shapewear that actually works—pieces that support you physically and boost your confidence emotionally.",
  mission: "We're not about changing who you are. We're about celebrating who you are while giving you the tools to feel your absolute best. Our waist trainers and shapewear are designed with real bodies in mind—offering comfort, support, and that extra confidence boost you deserve.",
  difference: "What makes us different? We combine premium quality with authentic body positivity. No filters, no false promises—just real support for real women."
};

const AboutSection = () => {
  return (
    <section id="about" className="section-spacing bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-serif font-semibold text-foreground mb-6">
            {aboutData.headline}
          </h2>
          <div className="w-24 h-1 bg-accent-gold mx-auto rounded-full"></div>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Left column - Story */}
          <div className="space-y-6">
            <p className="text-lg text-muted-foreground font-sans leading-relaxed">
              {aboutData.story}
            </p>
            <p className="text-lg text-muted-foreground font-sans leading-relaxed">
              {aboutData.mission}
            </p>
          </div>

          {/* Right column - Difference */}
          <div className="bg-blush rounded-2xl p-8 md:p-10 shadow-lg">
            <div className="flex items-start gap-4 mb-6">
              <div className="p-3 bg-white rounded-full shadow-md">
                <Heart className="w-6 h-6 accent-gold" fill="#d4a574" />
              </div>
              <div>
                <h3 className="text-2xl font-serif font-semibold text-foreground mb-3">
                  What Makes Us Different
                </h3>
                <p className="text-base text-muted-foreground font-sans leading-relaxed">
                  {aboutData.difference}
                </p>
              </div>
            </div>

            <div className="space-y-4 mt-8">
              <div className="flex items-center gap-3">
                <Shield className="w-5 h-5 accent-gold flex-shrink-0" />
                <span className="text-foreground font-sans">Premium Quality Materials</span>
              </div>
              <div className="flex items-center gap-3">
                <Heart className="w-5 h-5 accent-gold flex-shrink-0" />
                <span className="text-foreground font-sans">Body-Positive Philosophy</span>
              </div>
              <div className="flex items-center gap-3">
                <Users className="w-5 h-5 accent-gold flex-shrink-0" />
                <span className="text-foreground font-sans">Supportive Community</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
